module.exports = __webpack_public_path__ + "img/99.817123d0.jpg";